// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"c6323bb0","41":"5c99a700","88":"33a92401","134":"4b93810b","240":"37c2a524","357":"beec1ed1","364":"d26a9698","651":"9bd6729c","690":"58c2b729","754":"5c99a700","815":"5c99a700","955":"e6c04b11"}[chunkId] + ".chunk.css";
};